import React, { Component } from "react";
import styled from "styled-components";
import { mapStateToProps } from "../../redux/store";
import { connect } from "react-redux";
import {
  addProduct,
  changeAttribute,
  removeProduct,
} from "../../redux/features/cartSlice";
const Product = styled.div`
  display: flex;
  align-items: stretch;
  gap: 5px;
  & + & {
    margin-top: 2.5rem;
  }
`;
const ProductDetails = styled.div`
  flex: 3;
`;
const ProductBrand = styled.div`
  font-weight: 300;
`;
const ProductName = styled.div`
  font-weight: 300;
  line-height: 160%;
  margin-bottom: 0.5rem;
`;
const ProductPrice = styled.div`
  font-weight: 500;
  margin-bottom: 0.5rem;
`;
const ProductAttribute = styled.div`
  font-size: 14px;
  & + & {
    margin-top: 0.5rem;
  }
`;
const AttributeName = styled.div`
  margin-bottom: 0.5rem;
`;
const AttributeValues = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const AttributeValue = styled.div`
  font-size: 14px;
  color: ${({ name, value, selectedAttributes }) =>
    selectedAttributes[name] === value ? "white" : "black"};
  background-color: ${({ selectedAttributes, name, value, type }) =>
    selectedAttributes[name] === value && type === "text" && "black"};
  background-color: ${({ color }) => color};
  border: ${({ color, selectedAttributes, name, value }) =>
    color && selectedAttributes[name] === value
      ? "solid 2px #5ECE7B"
      : "1px solid black"};
  min-height: ${({ color }) => (color ? "20px" : "32px")};
  min-width: ${({ color }) => (color ? "20px" : "32px")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  font-family: "Source Sans Pro", sans-serif;
  cursor: pointer;
  user-select: none;
`;
const ProductActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  user-select: none;
`;
const IncrementProduct = styled.div`
  height: 24px;
  width: 24px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  cursor: pointer;
`;
const ProductQuantity = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  font-weight: 500;
  cursor: default;
`;
const DecrementProduct = styled.div`
  height: 24px;
  width: 24px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  cursor: pointer;
`;
const ProductPicture = styled.div`
  flex: 2;
  align-items: stretch;
`;
const Image = styled.img`
  height: 100%;
  object-fit: contain;
`;
class NavProduct extends Component {
  render() {
    if (this.props.product.productDetails) {
      const { name, brand, prices, attributes, gallery, selectedAttributes } =
        this.props.product.productDetails;
      const selectedPrice = prices.find(
        (price) => price.currency.label === this.props.currencyState.label
      );
      return (
        <Product>
          <ProductDetails>
            <ProductBrand>{brand}</ProductBrand>
            <ProductName>{name}</ProductName>
            <ProductPrice>
              {selectedPrice?.currency.symbol}
              {selectedPrice?.amount.toFixed(2)}
            </ProductPrice>
            {attributes.map((attribute) => {
              return (
                <ProductAttribute key={attribute.name}>
                  <AttributeName>{attribute.name}</AttributeName>
                  <AttributeValues>
                    {attribute.items.map((item) => {
                      if (attribute.type === "swatch")
                        return (
                          <AttributeValue
                            key={item.value}
                            color={item.value}
                            name={attribute.name}
                            value={item.value}
                            type={attribute.type}
                            selectedAttributes={selectedAttributes}
                            onClick={() =>
                              this.props.dispatch(
                                changeAttribute({
                                  productDetails:
                                    this.props.product.productDetails,
                                  selectedAttributes: {
                                    ...this.props.product.productDetails
                                      .selectedAttributes,
                                    [attribute.name]: item.value,
                                  },
                                })
                              )
                            }
                          />
                        );
                      else
                        return (
                          <AttributeValue
                            key={item.value}
                            name={attribute.name}
                            value={item.value}
                            type={attribute.type}
                            selectedAttributes={selectedAttributes}
                            onClick={() =>
                              this.props.dispatch(
                                changeAttribute({
                                  productDetails:
                                    this.props.product.productDetails,
                                  selectedAttributes: {
                                    ...this.props.product.productDetails
                                      .selectedAttributes,
                                    [attribute.name]: item.value,
                                  },
                                })
                              )
                            }
                          >
                            {item.value}
                          </AttributeValue>
                        );
                    })}
                  </AttributeValues>
                </ProductAttribute>
              );
            })}
          </ProductDetails>
          <ProductActions>
            <IncrementProduct
              onClick={() =>
                this.props.dispatch(
                  addProduct({
                    productDetails: this.props.product.productDetails,
                  })
                )
              }
            >
              +
            </IncrementProduct>
            <ProductQuantity>{this.props.product.quantity}</ProductQuantity>
            <DecrementProduct
              onClick={() =>
                this.props.dispatch(
                  removeProduct({
                    productDetails: this.props.product.productDetails,
                  })
                )
              }
            >
              -
            </DecrementProduct>
          </ProductActions>
          <ProductPicture>
            <Image src={gallery[0]} />
          </ProductPicture>
        </Product>
      );
    }
  }
}
export default connect(mapStateToProps)(NavProduct);
